import genericRule from '../../../FORMS/namespace/relation/doingChange_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'savedFilter'
};
